import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { asset } from "../../../api/index.js";
import { toast } from "react-toastify";
import Plot from "react-plotly.js";
import { useNavigate } from "react-router-dom";
import { matar } from "../../../api/index.js";

const GroupWorkOrderDetail = () => {
  const navigate = useNavigate();
  console.log("testing");

  const params = useParams();
  const [assetData, setAssetData] = React.useState(null);
  const [chartQuarter, setChartQuarter] = React.useState([]);
  const [chart, setChart] = React.useState([]);

  async function getDataChartGroup() {
    try {
      const result = await matar.customMatar({
        method: "POST",
        url: "/api/v1/assets/1",
        queryParams: {
          chart: "WOGroup",
          group: params.groupId,
          location: params.locationId,
        },
      });
      if (result.ok) {
        const body = await result.json();
        const data = body.data?.data;
        const charts = [];
        const one = {
          x: [],
          y: [],
          type: "line",
          name: "Corrective Work Order Count",
          mode: "lines+markers",
          marker: { color: "#f39710" },
        };
        const two = {
          x: [],
          y: [],
          type: "line",
          name: "Failure Count",
          mode: "lines+markers",
          marker: { color: "#2fb5c9" },
        };
        const three = {
          x: [],
          y: [],
          type: "line",
          name: "Preventive Work Order Count",
          mode: "lines+markers",
          marker: { color: "#3bd2a2" },
        };
        data.forEach((item) => {
          one.x.push(item["Time"]);
          two.x.push(item["Time"]);
          three.x.push(item["Time"]);

          one.y.push(item["Corrective Work Order Count"]);
          two.y.push(item["Failure Count"]);
          three.y.push(item["Preventive Work Order Count"]);
        });
        charts.push(one);
        charts.push(two);
        charts.push(three);
        setChartQuarter(charts);
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    } finally {
    }
  }
  async function getDataChart() {
    try {
      const result = await matar.customMatar({
        method: "POST",
        url: "/api/v1/assets/1",
        queryParams: {
          chart: "WOGroupYearly",
          group: params.groupId,
          location: params.locationId,
        },
      });
      if (result.ok) {
        const body = await result.json();
        const data = body.data?.data;
        const charts = [];
        const one = {
          x: [],
          y: [],
          type: "bar",
          name: "Corrective Work Order Count",

          marker: { color: "#f39710" },
        };
        const two = {
          x: [],
          y: [],
          type: "bar",
          name: "Failure Count",

          marker: { color: "#2fb5c9" },
        };
        const three = {
          x: [],
          y: [],
          type: "bar",
          name: "Preventive Work Order Count",

          marker: { color: "#3bd2a2" },
        };
        data.forEach((item) => {
          one.x.push(item["Year"]);
          two.x.push(item["Year"]);
          three.x.push(item["Year"]);

          one.y.push(item["Corrective Work Order Count"]);
          two.y.push(item["Failure Count"]);
          three.y.push(item["Preventive Work Order Count"]);
        });
        charts.push(one);
        charts.push(two);
        charts.push(three);
        setChart(charts);
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    } finally {
    }
  }
  useEffect(() => {
    getDataChartGroup();
    getDataChart();
  }, []);
  return (
    <div style={{ m: 5 }}>
      <div p={5} className="widget" style={{ height: "auto", padding: "20px" }}>
        <div className="widget-wrapper">
          <div style={{ fontWeight: "bold", mb: 2 }}>
            Asset ID : {params.id}
          </div>
          <div>
            <table>
              <tr>
                <td>Asset Group</td>
                <td style={{ paddingRight: "5px", paddingLeft: "5px" }}>:</td>
                <td>{params.groupId}</td>
              </tr>
              <tr>
                <td>Asset Location</td>
                <td style={{ paddingRight: "5px", paddingLeft: "5px" }}>:</td>
                <td>{params.locationId}</td>
              </tr>
            </table>
          </div>
          <hr />
          <div style={{ height: "500px" }}>
            <h4>Work Order and Failure History</h4>
            <Plot
              style={{ display: "block" }}
              data={chart}
              layout={{
                legend: {
                  bgcolor: "#595959",
                },
                autosize: true,
                font: {
                  color: "#eaeaea",
                },
                xaxis: {
                  gridcolor: "#506784",
                  linecolor: "#506784",
                  textColor: "#eaeaea",
                  title: {
                    text: "Time",
                    font: {
                      size: 13,
                      color: "#efefef",
                    },
                  },
                },
                yaxis: {
                  gridcolor: "#506784",
                  linecolor: "#506784",
                  title: {
                    text: "Count",
                    font: {
                      size: 13,
                      color: "#eaeaea",
                    },
                  },
                },
                displayModeBar: false,
              }}
              config={{
                showlegend: true,
                displayModeBar: false,
                editable: false,
                scrollZoom: false,
                responsive: true,
                staticPlot: false,
              }}
            />
          </div>
          <hr />
          <div style={{ height: "500px" }}>
            <h4>Work Order and Failure History - Quarter</h4>
            <Plot
              style={{ display: "block" }}
              data={chartQuarter}
              layout={{
                autosize: true,
                legend: {
                  bgcolor: "#595959",
                },
                font: {
                  color: "#eaeaea",
                },
                xaxis: {
                  gridcolor: "#506784",
                  linecolor: "#506784",
                  textColor: "#eaeaea",
                  title: {
                    text: "Time",
                    font: {
                      size: 13,
                      color: "#efefef",
                    },
                  },
                },
                yaxis: {
                  gridcolor: "#506784",
                  linecolor: "#506784",
                  title: {
                    text: "Count",
                    font: {
                      size: 13,
                      color: "#eaeaea",
                    },
                  },
                },
                displayModeBar: false,
              }}
              config={{
                showlegend: true,
                displayModeBar: false,
                editable: false,
                scrollZoom: false,
                responsive: true,
                staticPlot: false,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupWorkOrderDetail;
